<template>
    <div>
        <div class="display-flex display-flex-space-between margin-top-20">
            <FilterExcersice class="flex-left" @handleSeach="handleSeach" />
            <div class="wrap-right display-flex justify-content-end flex-right">

                <a href="javascript:;" class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add"
                    @click="handleCreateExcercise">
                    <img class="icon-plus" src="@/assets/img/plus.png" />
                    <img class="icon-plus" src="@/assets/img/plus-hover.png" />
                    Tạo đề
                </a>
            </div>
        </div>
        <div class="wrap-list-subject margin-top-20">
            <div v-if="listData.length > 0" class="subject-item" v-for="(item, index) of listData" :key="index">
                <div @click="handleToggerCollapse(item)" class="title-subject">
                    {{ item.name }} ({{ item.listExcerciseNotScore.length }})
                    <img class="icon-down-arrow" src="@/assets/img/down-arrow.png" />
                </div>
                <b-collapse id="collapse_filter" class="mt-2" :visible="item.isCollapse">
                    <div class="list-excersice indented">
                        <div class="row header-excercise">
                            <div class="col-md-3 header-item">
                                Tên đề
                            </div>
                            <div class="col-md-3 header-item">
                                Số người đã nộp/ số người tham gia
                            </div>
                            <div class="col-md-3 header-item">
                                Số bài đã chấm
                            </div>
                            <div class="col-md-3 header-item">
                                Số bài đã trả điểm
                            </div>
                        </div>
                        <div class="row name-excercise list-excercise"
                            v-for="(itemExcercise, indexitemExcercise) of item.listExcerciseNotScore"
                            :key="indexitemExcercise">
                            <div @click="handleShowContentExcerciseNotScore(itemExcercise)" class="col-md-3">
                                {{ itemExcercise.name }}
                            </div>
                            <div class="col-md-3">
                                {{ itemExcercise.countMemberSubmit }}/{{ itemExcercise.countMemberAssign }}
                            </div>
                            <div class="col-md-3">
                                {{ itemExcercise.countExcerciseScore }}
                            </div>
                            <div class="col-md-3">
                                {{ itemExcercise.countExceciseSendMember }}
                            </div>
                        </div>
                    </div>
                </b-collapse>

            </div>
            <div v-if="listData.length == 0" class="row">
                <div class="col-md-12 empty-data text-center">Bài tập/ bài kiểm tra chưa chấm không có dữ liệu</div>
            </div>
        </div>
        <div class="row pagination container m-0">
            <b-pagination pills v-model="paramQueryData.pageIndex" :total-rows="totalRecords"
                :per-page="paramQueryData.pageSize" first-number last-number></b-pagination>
        </div>
    </div>
</template>
<script>
import { getListExcerciseNotScore } from './../../_api/LessonClassSchoolServices'

import FilterExcersice from './_components/FilterExcersice'
export default {
    components: {
        FilterExcersice,
    },
    data() {
        return {
            listData: [],
            totalRecords: 0,
            paramQueryData: {
                keyword: '',
                type: 3,
                pageIndex: 1,
                pageSize: 20,
                subjectId: 0,
                classId: 0,
                typeExcercise:0
            },
        }
    },
    watch: {
        'paramQueryData.pageIndex': 'getListDataNotScore',
        'paramQueryData.keyword': 'filterDataByKeyword'
    },
    mounted() {
        this.getListDataNotScore()
    },
    methods: {
        handleSeach(filter) {
            this.paramQueryData.keyword = filter.keyword
            this.paramQueryData.subjectId = filter.subjectId
            this.paramQueryData.classId = filter.classId
            this.paramQueryData.typeExcercise = filter.typeExcercise
            this.getListDataNotScore()
        },
        handleToggerCollapse(item) {
            item.isCollapse = !item.isCollapse
        },
        filterDataByKeyword() {
            this.paramQueryData.pageIndex = 1
            this.getListDataNotScore()
        },
        getListDataNotScore() {
            let self = this
            getListExcerciseNotScore(this.paramQueryData).then((res) => {
                if (res && res.data && !res.errors) {
                    self.listData = res.data.list
                    self.totalRecords = res.data.paging.totalRecords
                }
            })
        },
        handleShowContentExcerciseNotScore(item) {
            //this.$router.push({ path: '/noi-dung-de-thi-chua-cham' })
            const routeData = this.$router.resolve({ path: '/noi-dung-de-thi-chua-cham', query: { id: item.id ,classSchoolId:item.classSchoolId} });
            window.open(routeData.href, '_blank');
        },
        handleCreateExcercise() {
            const routeData = this.$router.resolve({ path: '/tao-bai-kiem-tra' });
            window.open(routeData.href, '_blank');
        }
    }
}
</script>
<style lang="scss" scoped>
.title-subject {
    cursor: pointer;
}

.wrap-list-subject {
    .subject-item {
        border-bottom: 1px solid #b9b9b9;

        .list-excersice {
            .header-excercise {
                .header-item {
                    font-size: 14px;
                    color: #afafaf;
                }
            }

            .name-excercise {
                cursor: pointer;
            }
        }
    }
}

.flex-left {
    flex: 2;
}

.flex-right {
    flex: 1;
}

.justify-content-end {
    justify-content: end;
}

.indented {
    margin-left: 20px;
    /* Đặt giá trị thụt cách tùy ý */
}

.margin-top-20 {
    margin-top: 20px;
}

.icon-plus {
    width: 20px;
    top: 0px !important;
    display: inline-block;
}

.display-flex-space-between {
    justify-content: space-between;
}

.icon-down-arrow {
    width: 15px;
    height: 15px;
}
</style>